import { render, staticRenderFns } from "./SupplierRiskModelByTechItem.vue?vue&type=template&id=1e83e947&scoped=true&"
import script from "./SupplierRiskModelByTechItem.vue?vue&type=script&lang=js&"
export * from "./SupplierRiskModelByTechItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e83e947",
  null
  
)

export default component.exports